import {TreeViewBaseItem} from '@mui/x-tree-view';
export function getParentIds(nodes: TreeViewBaseItem[], selectedId: string) {
  for (const node of nodes) {
    if (node.id === selectedId) {
      return [node.id];
    }

    if (node.children && node.children.length > 0) {
      const path: any = getParentIds(node.children, selectedId);

      if (path) {
        return [node.id, ...path];
      }
    }
  }

  return null;
}
